import styled from 'styled-components';

export const Container = styled.div`
    height: 100%;
    width: 100%;
    position: relative;
    text-align: center;

    > * {
        text-align: center;

        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        > .ant-spin-container {
        }
    }
   
}
`;